export const DatepickerDT = {
	datepicker: {
		fullWidth: '100%',
		css: ({ dt }) => `
          .p-datepicker-panel-clear {
            .p-datepicker-panel {
                padding: 0;
                border: none;
            }
          }
        `,
	},
};
